var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLongCurved2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 131,
    viewBox: "0 0 166 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99999 3.49883C1.17156 3.49883 0.49999 2.82726 0.49999 1.99883C0.49999 1.1704 1.17156 0.498825 1.99999 0.498825L1.99999 3.49883ZM97.9393 120.061C97.3536 119.475 97.3536 118.525 97.9393 117.939L107.485 108.393C108.071 107.808 109.021 107.808 109.607 108.393C110.192 108.979 110.192 109.929 109.607 110.515L101.121 119L109.607 127.485C110.192 128.071 110.192 129.021 109.607 129.607C109.021 130.192 108.071 130.192 107.485 129.607L97.9393 120.061ZM1.99999 0.498825C79.5418 0.498818 135.352 29.8495 156.167 59.6403C166.592 74.5605 168.423 89.9632 159.053 101.657C149.824 113.175 130.127 120.5 99 120.5L99 117.5C129.873 117.5 148.364 110.2 156.712 99.7806C164.921 89.5362 163.721 75.6886 153.708 61.3585C133.648 32.6487 78.9582 3.49882 1.99999 3.49883L1.99999 0.498825Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongCurved2);
export default __webpack_public_path__ + "static/media/arrow-long-curved2.2676c8c61b6e9cd44e7325ffd5e14d4e.svg";
export { ForwardRef as ReactComponent };